import styled from 'styled-components';

export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;

  button[disabled] {
    background-color: #b2b2b2;
    color: #d2d2d2;
    border: none;

    &:hover {
      background-color: #b2b2b2;
      color: #d2d2d2;
    }
  }

  @media (max-width: 425px) {
    flex-direction: column-reverse;
    gap: 20px;

    button {
      width: 100%;
    }
  }
`;
